import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class OutPostModalService {
  // private activatedOutpostId = new BehaviorSubject("");
  // public currentOutpostId = this.activatedOutpostId.asObservable();
  public activatedOutpostId = signal<any>("");

  // private activatedPlan = new BehaviorSubject(false);
  // public currentPlan = this.activatedPlan.asObservable();
  public activatedPlan = signal<boolean>(false);

  // private activatedBoardService = new BehaviorSubject(false);
  // public currentBoardService = this.activatedBoardService.asObservable();
  public currentBoardService = signal<boolean>(false);

  // private activatedGroomingService = new BehaviorSubject(false);
  // public currentGroomingService = this.activatedGroomingService.asObservable();
  public currentGroomingService = signal<boolean>(false);

  // private activatedCheckout = new BehaviorSubject(false);
  // public currentCheckout = this.activatedCheckout.asObservable();

  constructor() {}

  currentOutpost(outpost: any) {
    this.activatedOutpostId.update(() => outpost);
    // this.activatedOutpostId.next(outpost);
    // this.activatedPlann.set(false);
  }
  getCurrentPlanData(flag: boolean) {
    // this.activatedPlan.next(flag);
    // this.activatedPlan.set(flag);
    this.activatedPlan.update(() => !flag);
    this.activatedPlan.update(() => flag);
  }

  getCurrentBoardServiceData(flag: boolean) {
    // this.activatedBoardService.next(flag);
    this.currentBoardService.update(() => !flag);
    this.currentBoardService.update(() => flag);
  }

  getCurrentGroomingServiceData(flag: boolean) {
    // this.activatedGroomingService.next(flag);
    // this.currentGroomingServicee.set(flag);
    this.currentGroomingService.update(() => !flag);
    this.currentGroomingService.update(() => flag);
  }
  // getCheckoutData(flag: boolean) {
  //   this.activatedCheckout.next(flag);
  // }
}
